import PropTypes from 'prop-types'
import React from 'react'

const BooleanPillSkeleton = ({ boolean, loading }) => {
  let pillColor = boolean ? 'pill--green' : 'pill--red'
  let pillText = boolean ? 'True' : 'False'

  if (loading) {
    pillColor = 'pill--grey'
    pillText = 'Loading'
  }

  return (
    <span className={`pill ${pillColor}`}>
      {pillText}
    </span>
  )
}

BooleanPillSkeleton.propTypes = {
  boolean: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
}

export default BooleanPillSkeleton
